//import Platform from 'react-platform-js'

//-----BASE_URL Code--------
//export let BASE_URL = "https://stgapi.chroniclecloud.com/";
export let BASE_URL = "https://dev-api.anandaspa.com/";

// -----Device Type--------
export const device_type = 'web_app';
export const REACT_APP_ENCRYPTION_KEY = "aNanDArESoRT@1234!#$%&*";
//-----Device Version--------
//export const device_version = JSON.stringify(Platform.OS + " " + Platform.OSVersion);

//-----AdminProfile Text--------
export const YOU_FIRST_NAME_HAS_BEEN_UPDATED = "Your first name has been updated.";
export const YOU_LAST_NAME_HAS_BEEN_UPDATED = "Your last name has been updated.";
export const YOU_FIRST_AND_LAST_NAME_HAS_BEEN_UPDATED = "Your first name and last name has been updated.";
export const PASSWORD_CHANGE_SUCCESSFULLY = "Password Changed successfully.";
export const PROFILE_DETAILS_FETCHED_SUCCESSFULLY = "Profile details fetched successfully";

export const NAME_REGEX = /^[a-zA-Z\s]+$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
export const PASSWORD_REGEX = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}[\]|\\:;\"'<>,.?/_₹]).{8,15}$/;
export const PHONE_REGEX = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
export const MOBILE_NUMBER_REGEX=/^[+]{1}[0-9]+[-]{1}[0-9]+$/
export const POSITIVE_NUMBER = /^\d*\.?\d*$/;

//-----Login Text--------
export const EMAIL_IS_REQUIRED = "Email is required!";
export const THIS_IS_NOT_A_VALID_EMAIL_FORMAT = "This is not a valid email format!";
export const PASSWORD_IS_REQUIRED = "Password is required!";
export const PASSWORD_MUST_BE_MORE_THAN_8_CHARACTERS = "Password must be more than 8 characters";
export const PASSWORD_CANNOT_EXCEED_MORE_THAN_20_CHARACTERS = "Password cannot exceed more than 20 characters";
export const THIS_IS_NOT_A_VALID_PASSWORD_FORMAT = "This is not a valid password format!";

//-----AddMember Text--------
export const PHONE_NUMBER_IS_REQUIRED = "Phone Number is required!";
export const THIS_IS_NOT_A_VALID_PHONE_NUMBER_FORMAT = "This is not a valid phone number format!";
export const USER_ROLE_IS_REQUIRED = "User Role is required!";
export const FIRST_NAME_IS_REQUIRED = "First Name is required!";
export const LAST_NAME_IS_REQUIRED = "Last Name is required!";

//-----AddRecipe Text--------
export const TITLE_IS_REQUIRED = "Title is required!";
export const TYPE_IS_REQUIRED = "Type is required!";
export const CALORIES_IS_REQUIRED = "Calories is required!";
export const ENTER_CALORIES_IN_NUMBER = "Enter Calories in Number!";
export const DOSHA_IS_REQUIRED = "Dosha is required!";
export const CAL_IS_REQUIRED = "Cal is required!";
export const PROTEIN_IS_REQUIRED = "Protein is required!";
export const FAT_IS_REQUIRED = "Fat is required!";
export const PORTION_IS_REQUIRED = "Portion is required!";
export const MINUTES_IS_REQUIRED = "Minutes is required!";
export const CARB_IS_REQUIRED = "Carb is required!";
export const PROGRESS_REPORT_START= 1680307200000;

export const guestType = {
    ENROLLED:'enrolled',
    ALL: 'All'
}

export const monthsOptions = [
    { label: 'Jan', value: 1 },
    { label: 'Feb', value: 2 },
    { label: 'Mar', value: 3 },
    { label: 'Apr', value: 4 },
    { label: 'May', value: 5 },
    { label: 'Jun', value: 6 },
    { label: 'Jul', value: 7 },
    { label: 'Aug', value: 8 },
    { label: 'Sep', value: 9 },
    { label: 'Oct', value: 10 },
    { label: 'Nov', value: 11 },
    { label: 'Dec', value: 12 }
  ];


const startYear = 2022;
const currentYear = new Date().getFullYear();

export const yearsOptions = Array(currentYear - startYear + 1)
.fill()
.reduce((acc, _, index) => {
  acc.push({
    label: `${startYear + index}`, 
    value: startYear + index     
  });
  return acc;
}, []);

//data type
export const TINYINT= "tinyint"
export const STRING= "string"
export const INT= "int"
export const DATETIME= "datetime"
export const DATE= "date"
export const JSON_TYPE= "json"
export const ENUM= "enum"
export const DROPDOWN= "dropdown"

//operators
export const EMPTY='empty'
export const NOT_EMPTY='not_empty'
export const IS='is'
export const IS_NOT='is_not'
export const CONTAINS='contains'
export const NOT_CONTAINS='not_contains'
export const START_WITH='starts_with'
export const END_WITH='ends_with'
export const LESS_THAN='less_than'
export const LESS_THAN_EQUAL='less_than_eq'
export const GREATER_THAN='greater_than'
export const GREATER_THAN_EQUAL='greater_than_eq'

export const announcementVisibility=[
  { label: 'All', value: 'all' },
  { label: 'Active Guest', value: 'active_guest' },
  { label: 'Upcoming Guest', value: 'upcoming_guest' },
  { label: 'Completed Guest', value: 'completed_guest' },
  { label: 'Download Guest', value: 'download_guest'},
]

export const announcementGuestType=[
  { label: 'All', value: 'all' },
  { label: 'Wellness Guest', value: 'wellness_guest' },
  { label: 'Non Wellness Guest', value: 'non_wellness_guest' }
]

export const roleTypes=[
  { label: 'Admin', value: 'admin' },
  { label: 'Wellness', value: 'wellness' },
]

export const tabKeys ={
  "masterData": {
    PROGRAMS: "Program Master",
    ASSESSMENT: "Assessment",
    ACTIVITY: "Activity",
    RECIPE_COLLECTION: "Recipe Collection",    
  },
  "userManagement":{
    GUEST_USER: "Guest User",
    DOWNLOADS: "Downloads",
    TEAM_MEMBER: "Team Member",
    USER_ROLE: "User Role",
    ACCESS_MANAGEMENT: "Access Management",
    DELETE_REQUESTS: "Delete Requests"
  },

  "contentManagement":{
    VIDEO_AUDIO: "Video Audio",
    ARTICLES: "Articles",
    ANNOUNCEMENT: "Announcement",
  },

  "reports":{
    PROGRAM_FEEDBACK: "Program Feedback",
    GUEST_DINACHARYA: "Guest Dinacharya",
    TESTIMONIALS: "Testimonials", 
    QMS_SCORECARD: "QMS Scorecard",
    QMS_FEEDBACK_REPORT: "Feedback Report",
    GUEST_COMMENTS: "Guest Comments",
    CONSULTANT_RATINGS: "Consultant Ratings",
    THERAPIST_SESSIONS: "Therapist Sessions"
  }

}